module.exports = "<iframe [src]=\"url\" style=\"border: 0\"  width=\"100%\" height=\"100%\"></iframe>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/external-billing/external-unprocess-claims/external-unprocess-claims.component.html
// module id = 2447
// module chunks = 66